import { useLang } from "hooks/useLang";
import Image from "next/image";
import Rounds_ar from "./rounds_ar.json";
import Rounds from "./rounds.json";

const RoundComponent = ({ img, index }: { img: string; index: number }) => {
    const { lang } = useLang();


    return <div

        className={`relative gap-2 ${lang === "ar" ? "ml-4" : "mr-4"} flex  w-[270px] h-[200px] shadow-md rounded-[5px] cursor-auto `}
    >


        {/* Black overlay */}
        <div className="absolute inset-0 z-10 rounded-[5px]" />

        <div className="w-[290px] h-full flex flex-col ">
            <Image
                src={"https://passticketsstorage.blob.core.windows.net/images/f1-2025" + "/f1/rounds/race_bg.png"}
                alt="Background"
                fill
                priority
                sizes="400px"
                className="absolute inset-0 object-cover rounded-[5px] "
            />

            {/* Overlay Image */}
            <div className="absolute inset-0 flex items-center justify-center">
                <img
                    src={"https://passticketsstorage.blob.core.windows.net/images/f1-2025" + img}
                    alt="Round"
                    className="w-full h-full object-cover "
                />
            </div>

        </div>
    </div>

};

const RenderRounds = () => {
    const { lang } = useLang();
    const data = lang === "ar" ? Rounds_ar : Rounds;

    return (
        <div className="flex flex-row  h-auto ">

            {data.map((item, index) => (
                <RoundComponent img={item.img} index={index} key={index} />
            ))}
        </div>
    );
};

export default RenderRounds;
